module.exports = "/images/ci.svg?4a43b84970d9cc505a76b92bb42aa234";